// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SelectSubject/Attention.less
// module id = 1652
// module chunks = 0